import {
  deprecated,
  deprecatedObjectProperty,
  deprecatedProperty
} from "./chunk-KJVJ4CFF.mjs";
import "./chunk-NDCDZYN6.mjs";
export {
  deprecated,
  deprecatedObjectProperty,
  deprecatedProperty
};
//# sourceMappingURL=deprecated.mjs.map